import { AssetTypes } from '@tassat/common-definitions';
import { Asset, AssetBalanceStatistics } from '@tassat/fred-definitions';
import { AssetTicker, AssetWithPrice } from '@tassat/fred-extended-definitions';
import { createSelector } from 'reselect';

import { getAllAssetsArrayWithPrice } from './assets';
import { getApiBalanceStats, getAssetBalanceStats } from './common';

export interface AssetBalancesWithPrice extends Partial<AssetBalanceStatistics> {
    security?: AssetWithPrice;
    currency?: Asset;
    assetType: string;
}

// TODO Update selectors to handle multiple ASSETS in the future
export const getAssetBalances = createSelector(
    [ getAssetBalanceStats, getAllAssetsArrayWithPrice ],
    (assetBalanceStats, assets): AssetBalancesWithPrice[] => {
        return Object.values(assetBalanceStats)
            .map((assetBalance) => {
                const matchingAsset = assets.find((asset) => asset.AssetId === assetBalance.AssetId);
                const USDAssetData = assets.find((asset) => asset.Ticker === AssetTicker.USD);

                return {
                    ...assetBalance,
                    AssetId: undefined,
                    security: matchingAsset,
                    currency: USDAssetData,
                    assetType: matchingAsset?.Type ?? AssetTypes.ASSET
                };
            });
    }
);
export const getApiBalances = createSelector(
    [ getApiBalanceStats, getAllAssetsArrayWithPrice ],
    (apiBalanceStats, assets): AssetBalancesWithPrice[] => {
        const apiBalances = Object.values(apiBalanceStats)
            .map((apiBalance) => {
                const matchingAsset = assets.find((asset) => asset.AssetId === apiBalance.AssetId);
                const USDAssetData = assets.find((asset) => asset.Ticker === AssetTicker.USD);

                return {
                    ...apiBalance,
                    security: assets.find((asset) => asset.AssetId === apiBalance.AssetId),
                    price: matchingAsset?.Price ?? 1,
                    ticker: matchingAsset?.Ticker,
                    assetType: matchingAsset?.Type ?? '',
                    currency: USDAssetData
                };
            });

        return apiBalances;
    }
);